const RULES = [
  ["Small on purpose", "We cap every run so nobody is a stranger by the second kilometre."],
  ["All paces", "Walk breaks count. Sprint finishes are optional."],
  ["No gatekeeping", "First run ever or fifth marathon, same energy."],
  ["Phones out", "Yes, we take the group photo. No, you don't have to post it."],
];

export const Rules = () => (
  <ul className="rules" data-testid="crew-rules">
    {RULES.map(([title, text]) => (
      <li key={title}>
        <strong>{title}</strong>
        <span>{text}</span>
      </li>
    ))}
  </ul>
);
